module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pagination.limit,
      "layout": "sizes, prev, pager, next",
      "total": _vm.pagination.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ea82e4e","hasScoped":false}!./src/app/components/paginationNew/paginationNew.html
// module id = 2957
// module chunks = 1